export const CONTENT_SECTION_TYPE_TEXT = "TEXT";
export const CONTENT_SECTION_TYPE_IMAGE = "IMAGE";
export const CONTENT_SECTION_TYPE_LINK = "LINK";
export const CONTENT_SECTION_TYPE_PDF = "PDF";
export const CONTENT_SECTION_TYPE_AUDIO = "AUDIO";
export const CONTENT_SECTION_TYPE_VIDEO = "VIDEO";
export const CONTENT_SECTION_TYPE_VIDEO_LINK = "VIDEO_LINK";
export const CONTENT_SECTION_TYPE_APPOINTMENT = "APPOINTMENT";
export const CONTENT_SECTION_TYPE_CUSTOM_CHALLENGE = "CUSTOM_CHALLENGE";
export const CONTENT_SECTION_TYPE_COMPETITIVE_CHALLENGE =
  "COMPETITIVE_CHALLENGE";

export const CONTENT_SECTION_TYPES = [
  CONTENT_SECTION_TYPE_TEXT,
  CONTENT_SECTION_TYPE_IMAGE,
  CONTENT_SECTION_TYPE_LINK,
  CONTENT_SECTION_TYPE_PDF,
  CONTENT_SECTION_TYPE_AUDIO,
  CONTENT_SECTION_TYPE_VIDEO,
  CONTENT_SECTION_TYPE_VIDEO_LINK,
  CONTENT_SECTION_TYPE_APPOINTMENT,
  CONTENT_SECTION_TYPE_CUSTOM_CHALLENGE,
  CONTENT_SECTION_TYPE_COMPETITIVE_CHALLENGE,
];
